<div class="container">

  <app-header-dialog [iconName]="'store_mall_directory'">
    {{ local_title }} - {{data.member_id}}
  </app-header-dialog>

  <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">

    <mat-form-field class="full-width" appearance="outline">
      <mat-label>Nome</mat-label>
      <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
        autocomplete="off">
      <mat-error *ngIf="entityForm.controls.name.hasError('required')">
        O nome é obrigatório
      </mat-error>
    </mat-form-field>

    <mat-form-field class="full-width" appearance="outline">
      <mat-label>Email</mat-label>
      <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.email"
        autocomplete="off">
      <mat-error *ngIf="entityForm.controls.email.hasError('required')">
        O email é obrigatório
      </mat-error>
    </mat-form-field>

    <mat-form-field class="full-width" appearance="outline">
      <mat-label>CPF</mat-label>
      <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.cpf"
        autocomplete="off">
      <mat-error *ngIf="entityForm.controls.cpf.hasError('required')">
        O CPF é obrigatório.
      </mat-error>
    </mat-form-field>

    <div style="height:140px;">
      <div *ngIf="data.category == 'Não Sócio'">

        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Categoria</mat-label>
          <mat-select [formControl]="entityForm.controls.nonMemberCategory_id">
            <mat-option *ngFor="let cat of categories" [value]="cat.id">
              {{ cat.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

      </div>
    </div>
    
  </form>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

    <button matTooltip='Update' mat-raised-button (click)="matDialogRef.close(['update',entityForm])"
      [disabled]="entityForm.invalid">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>

  </div>

</div>